import { Navigate, useLocation } from 'react-router-dom';

export default function ContactPathGuard({ children }) {
  const { pathname, search, hash } = useLocation();
  const canonicalPath = pathname.replace(/\/+$/, '');

  if (pathname !== canonicalPath) {
    return <Navigate to={{ pathname: canonicalPath, search, hash }} replace />;
  }

  return children;
}